import * as React from 'react';
type Props = {
  className?: string;
};
export function Calories({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Calories"
      className={className}
    >
      <path
        d="M33.5714 22.8534C33.5714 31.4363 27.9877 37.1429 19.6196 37.1429C12.1245 37.1429 7.14282 32.7367 7.14282 26.1274C7.14282 20.2831 9.10751 18.8143 9.10751 15.1731C9.10751 14.2857 8.98711 13.5973 8.98711 13.0006C8.98711 12.0062 9.57408 11.4248 10.447 11.4248C11.6962 11.4248 13.7349 12.2968 14.7282 14.3622C16.0714 11.4248 11.7507 7.18948 11.1613 6.46781C10.785 6.00883 10.5593 5.45806 10.5593 4.93788C10.5593 3.59154 11.7483 2.85718 13.5092 2.85718C21.6514 2.85718 33.5714 8.7627 33.5714 22.8534Z"
        stroke="currentColor"
      />
    </svg>
  );
}
